import { Form, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import { DfpTable } from 'components/molecules/Dokumenty/DfpTable';
import FormWrapper from 'components/molecules/FormWrapper';

import {
    EDruhCpSluzba,
    IDodatekAkcie,
    IDodatekIsins,
    IDodatekSluzbaTypes,
    dokumentDodatekDruhCpGet
} from 'services/dokumenty/dodatek';
import { NavyseniOstatniGet } from 'services/dokumenty/navyseni';

import { EPodTypDokumentu } from 'enums/dokumentyEnums';
import { EDruhCp } from 'enums/isin/udaje/druhCp';

interface IBezZaplaceni {
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
    signingDisabled: boolean;
    dodatekData?: IDodatekIsins;
}

const BezZaplaceni: React.FC<IBezZaplaceni> = ({ nextStep, prevStep, zadostID, signingDisabled, dodatekData }) => {
    const { dokumenty } = useContext(Context);
    const [form] = Form.useForm();
    const [cpData, setCpData] = useState<IDodatekAkcie>();
    const [DfpTableRender, DfpUcetRender, SouborRender, displayMode] = DfpTable(
        zadostID,
        () => {},
        form,
        true,
        'dodatek',
        dodatekData?.druhcp === EDruhCp.AKCIE && cpData?.zamestakcppn,
        signingDisabled
    );

    useEffect(() => {
        if (Object.keys(EDruhCpSluzba).includes(dodatekData?.druhcp!)) {
            dokumentDodatekDruhCpGet(zadostID, dodatekData?.druhcp! as keyof IDodatekSluzbaTypes)
                .then(rezp => {
                    setCpData(rezp as IDodatekAkcie);
                })
                .catch(() => setCpData(undefined));
        }
        if (
            dodatekData?.druhcp! === EDruhCp.AKCIE &&
            (dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.NAVYSENI ||
                dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.NAVYSENIDLT)
        ) {
            NavyseniOstatniGet(zadostID).then(rezp => setCpData(rezp as any));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {displayMode === 'soubor' ? (
                SouborRender()
            ) : displayMode === 'ucet' ? (
                DfpUcetRender()
            ) : (
                <FormWrapper onFinish={() => nextStep()}>
                    <Title level={5} text="DOKUMENT_DODATEK_DFP_TITLE" />
                    <Paragraph
                        text="DOKUMENT_DODATEK_DFP_TEXT"
                        style={{
                            display: 'block'
                        }}
                    />
                    {DfpTableRender()}
                    <Row className="button-row">
                        <ButtonComponent buttontext="ZPET" onClick={() => prevStep()} id="isinZpetBtn" type="default" />
                        <ButtonComponent buttontext="POKRACOVAT" id="isinPokracovatBtn" htmlType="submit" />
                    </Row>
                </FormWrapper>
            )}
        </>
    );
};

export default BezZaplaceni;
